import React, { useState } from 'react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { BillingHistory } from '@/components/billing/BillingHistory';
import { AccountCancellation } from '@/components/billing/AccountCancellation';
import { useAuth } from '@/contexts/AuthContext';
import { Navigate } from 'react-router-dom';

export default function BillingManagement() {
  const { user, loading } = useAuth();
  const [activeTab, setActiveTab] = useState('billing');

  if (loading) {
    return <div className="flex items-center justify-center min-h-screen">Loading...</div>;
  }

  if (!user) {
    return <Navigate to="/auth/login" replace />;
  }

  return (
    <div className="container mx-auto px-4 py-8 max-w-4xl">
      <Tabs value={activeTab} onValueChange={setActiveTab} className="w-full">
        <TabsList className="grid w-full grid-cols-2">
          <TabsTrigger value="billing">Billing & History</TabsTrigger>
          <TabsTrigger value="cancellation" className="text-destructive">Account Management</TabsTrigger>
        </TabsList>
        
        <TabsContent value="billing" className="mt-6">
          <BillingHistory />
        </TabsContent>
        
        <TabsContent value="cancellation" className="mt-6">
          <AccountCancellation />
        </TabsContent>
      </Tabs>
    </div>
  );
}